module.exports = __webpack_public_path__ + "static/it-business-hero-5e9219175e3e89551d71c0a1ac7c62c2.jpg";